import AnimatedSection from './AnimatedSection';

const SectionWrapper = ({ title, subtitle, children, id }) => {
  return (
    <section id={id} className="py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-6 lg:px-8">
        {(title || subtitle) && (
          <AnimatedSection>
            <div className="mb-10 max-w-3xl">
              {subtitle && <p className="text-gold uppercase tracking-[0.25em] text-sm font-semibold">{subtitle}</p>}
              {title && <h2 className="mt-3 text-3xl font-semibold text-white sm:text-4xl md:text-5xl">{title}</h2>}
            </div>
          </AnimatedSection>
        )}
        {children}
      </div>
    </section>
  );
};

export default SectionWrapper;
